// App.js (Parent component)
import React, { useState, useEffect } from 'react';
import Loading from './pages/Loading';
import ComingSoon from './pages/ComingSoon';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 4000); // Adjust time as needed (ms)
    return () => clearTimeout(timer);
  }, []);

  return isLoading ? <Loading/> : <ComingSoon />;
};

export default App;
